/**
 * feat_090 — Visibilidad configurable de chips por usuario
 *
 * Interpreta user.ticketChipsVisibility (JSON nullable).
 * NULL o ausente → todos los chips visibles (legacy behavior intacto).
 * Clave ausente en el objeto → chip visible.
 * Clave explícitamente false → chip oculto.
 *
 * Defensivo: acepta string JSON (por si MariaDB/Sequelize devuelve LONGTEXT sin parsear).
 */

export const ALL_CHIPS_VISIBLE = {
  attentionTime: true,
  clientSilence: true,
  ticketAge: true,
  expiration: true,
  contactState: true,
  whatsappLine: true,
  contactType: true,
  queue: true,
  tags: true,
};

/**
 * @param {object|null} user - user object from AuthContext
 * @returns {object} chips visibility config — all keys boolean
 */
export const getChipsVisibility = (user) => {
  let saved = user?.ticketChipsVisibility;
  if (!saved) return { ...ALL_CHIPS_VISIBLE };
  // Defensive: parse string if Sequelize didn't auto-parse LONGTEXT
  if (typeof saved === "string") {
    try {
      saved = JSON.parse(saved);
    } catch {
      return { ...ALL_CHIPS_VISIBLE };
    }
  }
  if (typeof saved !== "object" || Array.isArray(saved)) return { ...ALL_CHIPS_VISIBLE };
  return { ...ALL_CHIPS_VISIBLE, ...saved };
};

export default getChipsVisibility;
